/**
 * @desc 导出
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  Array<defs.appCenter.AppDomainMenuAggregateResponseDto>
>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/menu/export`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
